var rich_content_viewer_default = {
  "fontElementMap": "zMQbd",
  "wrapper": "i-J2R",
  "pluginContainerMobile": "-OW02",
  "viewer": "_8KqUl",
  "android": "Ai-5l",
  "rootedTraversedContent": "wF2i6",
  "atomic": "y6PZ5",
  "toolbar": "TiWh6",
  "block": "B4Mj3"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
